"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  allBrands: 'All brands',
  articles: 'Articles',
  brands: 'Brands',
  brandsX: 'Brands ({count})',
  callToActionCatalogueText: 'Call to action catalogue text',
  categoriesX: 'Categories ({count})',
  change: 'Change',
  clearSearchInput: 'Clear search input',
  close: 'Close',
  failedToSubmit: 'Failed to submit',
  favorites: 'Favorites',
  favouriteLists: 'Favourite lists',
  gotIt: 'Got it',
  internationalSponsorGreetings: 'Welcome gift',
  internationalSponsorMessage: '15% off your first order!',
  loading: 'Loading',
  logIn: 'Log in',
  loggedInAs: 'Logged in as',
  menu: 'Menu',
  myAccount: 'My account',
  myFavoriteProducts: 'My favorite products',
  nextCatalogue: 'Next catalogue',
  noOptions: 'No options',
  notifications: 'Notifications',
  open: 'Open',
  oriflameSweden: 'Oriflame Sweden',
  oriflameWallet: 'Oriflame Wallet',
  other: 'Other',
  popularProducts: 'Popular products',
  popularProductsInThisSearchQuery: 'Popular products in this search query',
  popularSearchQueries: 'Top result for',
  products: 'Products',
  productsX: 'Products ({count})',
  quickBuy: 'Quick buy',
  register: 'Register',
  search: 'Search',
  searchDesktop: 'Search 60+ brands, 1000+ beauty and nutrition products',
  seeAll: 'See all',
  seeAllCatalogues: 'See all catalogues',
  seeAllResultsFor: 'See all results ({count})',
  shopFor: 'Shop for',
  shoppingBag: 'Shopping bag',
  showAllResults: 'Show all results',
  signIn: 'Sign in',
  sponsorGreetings: 'Welcome gift from',
  sponsorMessage: '{firstName} {shortenedLastName}.',
  topAreaBannerDialogFallbackMessage: 'A friend from abroad has invited you to join our Beauty Community! Explore our products and unlock exclusive perks just for you!',
  topAreaBannerDialogFallbackTitle: 'Welcome to Oriflame!',
  topAreaBannerReferralMessage: 'Click to see more info!',
  view: 'View',
  viewWelcomeGiftInformation: 'View welcome gift information'
};
const translationsNamespace = exports.translationsNamespace = 'top-area';